<div class="v-one-filter">
  <div class="v-one-filter__container">
    <!-- Dropdown Button -->
    <div class="v-one-filter__button-wrapper">
      <v-one-dropdown-button
        class="v-one-filter__dropdown"
        [formControl]="filterControl"
        [options]="options()"
        [variant]="variant()"
        [placeholder]="placeholder()"
        [multiple]="true"
        [closeOnSelect]="closeOnSelect()"
        [showSelectionCount]="false"
        [customIconName]="'adjustments'"
        [iconPosition]="'left'"
        [iconType]="ICON_TYPE.FILLED"
        [iconRotateOnOpen]="false"
        [attr.aria-label]="placeholder()"
      />
    </div>

    <!-- Active Filter Chips -->
    @if (showChips() && hasActiveFilters()) {
      <div class="v-one-filter__chips" role="list">
        @for (option of activeFilterOptions(); track option.value) {
          <div class="v-one-filter__chip-item" role="listitem">
            <v-one-chips-tags
              [label]="option.label"
              [type]="'chip'"
              [chipVariant]="'filled'"
              [closeable]="true"
              [disabled]="disabled()"
              (closed)="removeFilter(option.value)"
            />
          </div>
        }
      </div>
    }
  </div>
</div>
